<div class="panel panel-default">
    <h2 mat-dialog-title style="color:#9b7544" class="text-center">Select Total days to take service {{max}}</h2>
    <div class="panel-body" style="margin:5px; border:#9b7544 2px solid">
      <div class="row" style="margin:10px">
        <div class="col-12 text-center" style="padding:5px" >
            <label>Choose session
              <input type="number" name="gg"
              min="1" [(ngModel)]="day"></label>
        </div>
       
      </div>
      <div class="row" style="margin:10px">
        <div class="col-12 text-center" style="padding:10px">
            <button class="btn btn-outline-success  "  (click)="setConfirm()"
            >Confirm</button>
            <button class="btn btn-outline-danger " (click)="close()">Cancel</button>
        </div>
      </div>
    </div>
  </div>